/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.
  Once you add a new route on this file it will be visible automatically on
  the Sidenav.
  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Argon Dashboard 2 MUI layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import VirtualReality from "layouts/virtual-reality";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Tutor from "Views/people/tutor/index";
import Parents from "Views/people/parents";
import SubAdmin from "Views/people/SubAdmin";
import Students from "Views/people/students";
import ClassMgt from "Views/Activities/ClassMgt";
import SupportTicket from "Views/Activities/SupportTicket";
import Ehc from "Views/Activities/Ehc";
import Referral from "Views/Activities/Referral";
import ReferralSettings from "Views/Activities/Referral/ReferralSettings";
import Spiff from "Views/Activities/Spiff";
import SpiffSettings from "Views/Activities/Spiff/SpiffSettings";
import Gamification from "Views/Activities/Gamification";
import ShortListTutors from "Views/Activities/ShortListTutors";
import Attendance from "Views/Activities/AllAttendance";
import AutomaticServiceReview from "Views/Activities/AutomaticServiceReview/ServiceReviewPage";
import CreditMapping from "Views/Activities/CreditMapping";
import TutorsPayroll from "Views/Activities/TutorsPayroll";
import DraftTutor from "Views/FinanceManagment/DraftTutorSalary";
import AllTransaction from "Views/FinanceManagment/AllTransaction";
import PaymentOrderHistory from "Views/FinanceManagment/PaymentOrderHistory";
import ClientBalance from "Views/FinanceManagment/ClientBalance";
import RaiseInvoice from "Views/FinanceManagment/RaiseInvoice";
import CallbackRequest from "Views/UsefulCorners/CallbackRequest";
import Faqs from "Views/UsefulCorners/Faqs";
import ContactList from "Views/UsefulCorners/ContactList";
import State from "Views/UsefulCorners/State";
import City from "Views/UsefulCorners/City";
import LevelLinking from "Views/UsefulCorners/LevelLinking";
import Academic from "Views/UsefulCorners/Academic";
import Product from "Views/UsefulCorners/Product";
import AllVideos from "Views/UsefulCorners/AllVideos";
import AddVideo from "Views/UsefulCorners/AllVideos/AddVideo";
import EditVideo from "Views/UsefulCorners/AllVideos/EditVideo";
import Referal from "Views/UsefulCorners/Referral";
import FAQ from "Views/UsefulCorners/FAQ";
import StudyHub from "Views/UsefulCorners/StudyHub";
import StudyMaterialForm from "Views/UsefulCorners/StudyHub/StudyMaterialForm";
import AddFAQ from "Views/UsefulCorners/FAQ/AddFAQ";
import EditFAQ from "Views/UsefulCorners/FAQ/EditFAQ";
import ViewFAQ from "Views/UsefulCorners/FAQ/ViewFAQ";
import TestUser from "Views/TestUser";
import Banner from "Views/Banner";
import AddBanner from "Views/Banner/AddBanner";
import EditBanner from "Views/Banner/EditBanner";
import AddProduct from "Views/UsefulCorners/Product/AddProduct";
import EditProduct from "Views/UsefulCorners/Product/EditProduct";
import ViewProductEnq from "Views/UsefulCorners/Product/ViewProductEnq";
import SupportTicketCategory from "Views/UsefulCorners/SupportTicketCategory";
import AddSupportTicketCategory from "Views/UsefulCorners/SupportTicketCategory/AddCategory";
import EditSupportTicketCategory from "Views/UsefulCorners/SupportTicketCategory/EditCategory";
import Blogs from "Views/Blogs";
import AddBlog from "Views/Blogs/AddBlog";
import EditBlog from "Views/Blogs/EditBlog";
import StudentLeaderBoard from "Views/StudentLeaderBoard";
import TutorLeaderBoard from "Views/TutorLeaderBoard";
import IncomeBreakDown from "Views/Report/IncomeBreakDown";
import IncomeOverTime from "Views/Report/IncomeOverTime";
import NewEnq from "Views/Enquiry/NewEnq";
import QualifiedEnq from "Views/Enquiry/QualifiedEnq";
import DisQualifiedEnq from "Views/Enquiry/DisQualiFiedEnq";
import PendingEnq from "Views/Enquiry/PendingEnq";
import AddTutor from "Views/people/SubAdmin/AddTutor";
import AddTicket from "Views/Activities/SupportTicket/AddTicket";
import TutorsProfile from "Views/people/tutor/TutorsProfile";
import ParentProfile from "Views/people/parents/parentProfile";
import InvoiceView from "Views/people/parents/parentProfile/invoiceView";
import InvoiceFullHistory from "Views/people/parents/parentProfile/invoiceFullHistory";
import EditUser from "Views/people/SubAdmin/editUser";
import ClassSummary from "Views/Activities/ClassMgt/classSummary/index";
import EhcView from "Views/Activities/Ehc/ehcView";
import ViewEHC from "Views/Activities/Ehc/ViewEHC";
import AddEHC from "Views/Activities/Ehc/AddEHC";
import AttendanceListView from "Views/Activities/AllAttendance/AttendanceListView";
import CreditMappingView from "Views/Activities/CreditMapping/creditMappingView";
import TutorsPayrollView from "Views/Activities/TutorsPayroll/TutorsPayrollView";
import Notification from "Views/Communication/notification";
import AddNotification from "Views/Communication/notification/AddNotiFication";
import OtpLogs from "Views/Communication/OtpLogs";
import MessageControls from "Views/Communication/MessageControls";
import DraftTutorView from "Views/FinanceManagment/DraftTutorSalary/DrafTutorView";
import QuestionMgmt from "Views/UsefulCorners/QuestionMgmt";
import AddQuestion from "Views/UsefulCorners/QuestionMgmt/AddQuestionView";
import EditQuestionView from "Views/UsefulCorners/QuestionMgmt/EditQuestionView";
import AddFaqs from "Views/UsefulCorners/Faqs/AddFaqs";
import AddState from "Views/UsefulCorners/State/AddState";
import AddCity from "Views/UsefulCorners/City/AddCity";
import AddAcademic from "Views/UsefulCorners/Academic/AddAcademic";
import PlanManagement from "Views/UsefulCorners/PlanManagement";
import InitializationPlan from "Views/UsefulCorners/PlanManagement/InitializationPlan";
import StudentReview from "Views/UsefulCorners/PlanManagement/StudentReview";
import BenefitsManagement from "Views/UsefulCorners/PlanManagement/BenefitsManagement";
import CounselorDetailsManagement from "Views/UsefulCorners/PlanManagement/CounselorDetailsManagement";
import RegistrationFeesManagement from "Views/UsefulCorners/PlanManagement/RegistrationFeesManagement";
import EHCPlanManagement from "Views/UsefulCorners/EHCPlanManagement";
// import AddProduct from "Views/UsefulCorners/Product/AddProduct";
import EditFaqs from "Views/UsefulCorners/Faqs/EdutFaqs";
import FeedbackList from "Views/feedback/index";
import EditCity from "Views/UsefulCorners/City/EditCity";
import EditAcademic from "Views/UsefulCorners/Academic/EditAcademic";
// import EditProduct from "Views/UsefulCorners/Product/EditProduct";
import NewEnquiries from "Views/Enquiry/NewEnq/newEnqView";
import Qualifiedview from "Views/Enquiry/NewEnq/qualifiedView";
import RevenueSnapshot from "Views/Report/RevenueSnapshot";
import UnifiedCRM from "Views/Crm/UnifiedCrm";
import IndexPage from "Views/IndexPage";
import Curriculum from "Views/Curriculum";
import AddClass from "Views/Curriculum/Class/AddClass";
import EditClass from "Views/Curriculum/Class/EditClass";
import AddBoard from "Views/Curriculum/Board/AddBoard";
import EditBoard from "Views/Curriculum/Board/EditBoard";
import AddSubject from "Views/Curriculum/Subject/AddSubject";
import EditSubject from "Views/Curriculum/Subject/EditSubject";
import AddTimeSlot from "Views/Curriculum/timeSlot/AddTime";
import EditTimeSlot from "Views/Curriculum/timeSlot/EditTime";
import DemoList from "Views/Demo/DemoList";
import CreateDemo from "Views/Demo/CreateDemo";
import EditDemo from "Views/Demo/EditDemo";
import ViewDemo from "Views/Demo/ViewDemo";
import CompanyManagement from "Views/CompanyManagement";
import EducatorPolicy from "Views/people/tutor/EducatorPolicy";
import InHouseAts from "Views/Ats";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import invoiceView from "Views/people/parents/parentProfile/invoiceView";

const routes = [
  {
    type: "route",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <ArgonBox component="i" color="#4CAF50" fontSize="18px" className="ri-home-5-fill" />,
    component: <Dashboard />,
    permission: ["ALL", "dashboard"],
  },
  {
    type: "route",
    name: "CRM",
    key: "crm",
    route: "/crm",
    icon: (
      <ArgonBox component="i" color="#FF9800" fontSize="18px" className="ri-bar-chart-box-fill" />
    ),
    component: <UnifiedCRM />,
    permission: ["ALL", "crm"],
  },
  {
    type: "route",
    name: "In-House ATS",
    key: "in-house-ats",
    route: "/in-house-ats",
    icon: <ArgonBox component="i" color="#6f42c1" fontSize="18px" className="ri-briefcase-4-fill" />,
    component: <InHouseAts />,
    permission: ["ALL"],
  },
  {
    type: "route",
    name: "People",
    key: "people",
    // route: "/people",
    icon: <ArgonBox component="i" color="#1976D2" fontSize="18px" className="ri-group-fill" />,
    // component: <Tables />,
    collapse: [
      {
        name: "Tutors",
        key: "tutors",
        route: "/tutors",
        icon: (
          <ArgonBox
            component="i"
            color="#64dd13ff"
            sx={{ fontWeight: "medium" }}
            fontSize="19px"
            className="ri-presentation-line"
          />
        ),
        component: <Tutor />,
        permission: ["ALL", "tutors"],
      },
      {
        name: "Educator Policy",
        key: "educator-policy",
        route: "/educator-policy",
        icon: (
          <ArgonBox
            component="i"
            color="#5e72e4"
            fontSize="18px"
            className="ri-file-text-line"
          />
        ),
        component: <EducatorPolicy />,
        permission: ["ALL", "tutors"],
      },
      {
        name: "Parents",
        key: "parents",
        route: "/parents",
        icon: <ArgonBox component="i" color="primary" fontSize="18px" className="ri-user-2-fill" />,
        component: <Parents />,
        permission: ["ALL", "parents"],
      },
      // {
      //   name: "Students",
      //   key: "students",
      //   route: "/students",
      //   icon: (
      //     <ArgonBox
      //       component="i"
      //       color="primary"
      //       fontSize="18px"
      //       className="ri-graduation-cap-fill"
      //     />
      //   ),
      //   component: <Students />,
      //   permission: ["ALL", "students"],
      // },
      {
        name: "Sub Admin",
        key: "subadmin",
        route: "/subadmin",
        icon: <ArgonBox component="i" color="primary" fontSize="18px" className="ri-admin-fill" />,
        component: <SubAdmin />,
        permission: ["ALL", "subAdmin"],
      },
    ],
  },
  {
    type: "route",
    name: "Curriculum",
    key: "curriculum",
    route: "/curriculum",
    icon: <ArgonBox component="i" color="#FF5722" fontSize="18px" className="ri-book-2-fill" />,
    component: <Curriculum />,
    permission: [
      "ALL",
      "curriculum",
      "class",
      "board",
      "subject",
      "slots",
      "category",
      "qualification",
    ],
  },
  {
    type: "route",
    name: "Plan Management",
    key: "planmanagement",
    icon: (
      <ArgonBox component="i" color="#E91E63" fontSize="18px" className="ri-price-tag-3-fill" />
    ),
    permission: ["ALL", "plan"],
    collapse: [
      {
        name: "Purchase Plans",
        key: "manage-plans",
        route: "/planmanagement",
        icon: (
          <ArgonBox component="i" color="#E91E63" fontSize="18px" className="ri-settings-4-fill" />
        ),
        component: <PlanManagement />,
        permission: ["ALL", "plan"],
      },
      {
        name: "Proposal Plan",
        key: "initialization-plan",
        route: "/planmanagement/initialization",
        icon: (
          <ArgonBox component="i" color="#E91E63" fontSize="18px" className="ri-file-list-3-fill" />
        ),
        component: <InitializationPlan />,
        permission: ["ALL", "plan"],
      },
      {
        name: "Student Review",
        key: "student-review",
        route: "/planmanagement/reviews",
        icon: <ArgonBox component="i" color="#E91E63" fontSize="18px" className="ri-star-fill" />,
        component: <StudentReview />,
        permission: ["ALL", "plan"],
      },
      {
        name: "Plan Benefits",
        key: "benefits-management",
        route: "/planmanagement/benefits",
        icon: <ArgonBox component="i" color="#E91E63" fontSize="18px" className="ri-gift-fill" />,
        component: <BenefitsManagement />,
        permission: ["ALL", "plan"],
      },
      {
        name: "Counselor Details",
        key: "counselor-details-management",
        route: "/planmanagement/counselordetails",
        icon: (
          <ArgonBox component="i" color="#E91E63" fontSize="18px" className="ri-user-voice-fill" />
        ),
        component: <CounselorDetailsManagement />,
        permission: ["ALL", "plan"],
      },
      {
        name: "Registration Fees",
        key: "registration-fees-management",
        route: "/planmanagement/registrationfees",
        icon: (
          <ArgonBox
            component="i"
            color="#E91E63"
            fontSize="18px"
            className="ri-money-dollar-circle-fill"
          />
        ),
        component: <RegistrationFeesManagement />,
        permission: ["ALL", "plan"],
      },
    ],
  },
  {
    type: "route",
    name: "Demo Management",
    key: "demo",
    route: "/demos",
    icon: (
      <ArgonBox component="i" color="#9C27B0" fontSize="18px" className="ri-presentation-line" />
    ),
    permission: ["ALL", "demo"],
    component: <DemoList />,
  },
  {
    type: "route",
    name: "Activities",
    key: "Activities",
    // route: "/Activities",
    icon: <ArgonBox component="i" color="warning" fontSize="18px" className="ri-todo-line" />,
    // component: <Billing />,
    collapse: [
      {
        name: "Class Management",
        key: "mgt",
        route: "/classes",
        icon: <ArgonBox component="i" color="#4CAF50" fontSize="18px" className="ri-book-2-fill" />,
        component: <ClassMgt />,
        permission: ["ALL", "class_mgt"],
      },
      {
        name: "Support ticket",
        key: "support",
        route: "/supportticket",
        icon: (
          <ArgonBox component="i" color="#FF9800" fontSize="18px" className="ri-ticket-2-fill" />
        ),
        component: <SupportTicket />,
        permission: ["ALL", "support_ticket"],
      },
      {
        name: "EHC",
        key: "ehc",
        route: "/ehc",
        icon: <ArgonBox component="i" color="primary" fontSize="18px" className="ri-user-3-fill" />,
        component: <Ehc />,
        permission: ["ALL", "ehc"],
      },
      {
        name: "Referral",
        key: "referl",
        route: "/referal",
        icon: (
          <ArgonBox component="i" color="primary" fontSize="18px" className="ri-id-card-fill" />
        ),
        component: <Referral />,
        permission: ["ALL", "referral"],
      },
      {
        name: "Referral Settings",
        key: "referral-settings",
        route: "/referral-settings",
        icon: (
          <ArgonBox component="i" color="primary" fontSize="18px" className="ri-settings-4-fill" />
        ),
        component: <ReferralSettings />,
        permission: ["ALL", "referral"],
      },
      {
        name: "SPIFF",
        key: "spiff",
        route: "/spiff",
        icon: (
          <ArgonBox component="i" color="#F59E0B" fontSize="18px" className="ri-trophy-fill" />
        ),
        component: <Spiff />,
        permission: ["ALL", "spiff"],
      },
      {
        name: "SPIFF Settings",
        key: "spiff-settings",
        route: "/spiff-settings",
        icon: (
          <ArgonBox component="i" color="#F59E0B" fontSize="18px" className="ri-settings-4-fill" />
        ),
        component: <SpiffSettings />,
        permission: ["ALL", "spiff"],
      },
      {
        name: "Gamification",
        key: "gamification",
        route: "/gamification",
        icon: (
          <ArgonBox component="i" color="#7C3AED" fontSize="18px" className="ri-medal-fill" />
        ),
        component: <Gamification mode="eligibility" />,
        permission: ["ALL", "gamification"],
      },
      {
        name: "Gamification Settings",
        key: "gamification-settings",
        route: "/gamification-settings",
        icon: (
          <ArgonBox component="i" color="#7C3AED" fontSize="18px" className="ri-settings-4-fill" />
        ),
        component: <Gamification mode="settings" />,
        permission: ["ALL", "gamification"],
      },
      {
        name: "Shortlist Tutors",
        key: "shortlist",
        route: "/shortlistUser",
        icon: (
          <ArgonBox
            component="i"
            color="primary"
            fontSize="18px"
            className="ri-presentation-fill"
          />
        ),
        component: <ShortListTutors />,
        permission: ["ALL", "shortlist_tutors"],
      },
      {
        name: "All Attendance",
        key: "attendance",
        route: "/attendance",
        icon: (
          <ArgonBox component="i" color="primary" fontSize="18px" className="ri-history-line" />
        ),
        component: <Attendance />,
        permission: ["ALL", "attendance"],
      },
      {
        name: "Automatic Service Review",
        key: "automatic-service-review",
        route: "/automatic-service-review",
        icon: (
          <ArgonBox component="i" color="#E53935" fontSize="18px" className="ri-alarm-warning-fill" />
        ),
        component: <AutomaticServiceReview />,
        permission: ["ALL", "serviceReview"],
      },
      {
        name: "Credit Mapping",
        key: "credit",
        route: "/creditmapping",
        icon: (
          <ArgonBox component="i" color="primary" fontSize="18px" className="ri-history-fill" />
        ),
        component: <CreditMapping />,
        permission: ["ALL", "credit_mapping"],
      },
      {
        name: "Tutor's Payroll",
        key: "tutorpayroll",
        route: "/tutorpayroll",
        icon: (
          <ArgonBox
            component="i"
            color="primary"
            fontSize="18px"
            className="ri-money-dollar-circle-fill"
          />
        ),
        component: <TutorsPayroll />,
        permission: ["ALL", "tutor_payroll"],
      },
    ],
  },
  {
    type: "route",
    name: "Useful Corners",
    key: "useful",
    icon: <ArgonBox component="i" color="#0097A7" fontSize="18px" className="ri-folder-2-fill" />,
    permission: ["ALL", "question", "academic", "product", "video", "banner", "blogs", "faq", "studyHub"],
    collapse: [
      {
        name: "Company",
        key: "company",
        route: "/company-management",
        icon: (
          <ArgonBox component="i" color="#9C27B0" fontSize="18px" className="ri-building-line" />
        ),
        component: <CompanyManagement />,
        permission: ["ALL", "company"],
      },
      {
        name: "Question Mgmt",
        key: "questions",
        route: "/videoquestionsmanagement",
        icon: (
          <ArgonBox
            component="i"
            color="primary"
            fontSize="18px"
            className="ri-question-answer-line"
          />
        ),
        component: <QuestionMgmt />,
        permission: ["ALL", "question"],
      },
      {
        name: "Academic",
        key: "acedemic",
        route: "/academic",
        icon: <ArgonBox component="i" color="primary" fontSize="18px" className="ri-book-2-line" />,
        component: <Academic />,
        permission: ["ALL", "academic"],
      },
      {
        name: "Product",
        key: "product",
        route: "/product",
        icon: (
          <ArgonBox
            component="i"
            color="primary"
            fontSize="18px"
            className="ri-shopping-bag-line"
          />
        ),
        component: <Product />,
        permission: ["ALL", "product"],
      },
      {
        name: "Support Category",
        key: "supportticketcategory",
        route: "/useful-corners/support-ticket-category",
        icon: (
          <ArgonBox
            component="i"
            color="primary"
            fontSize="18px"
            className="ri-folder-settings-line"
          />
        ),
        component: <SupportTicketCategory />,
        permission: ["ALL", "supportTicket"],
      },
      {
        name: "All videos",
        key: "videos",
        route: "/allvideos",
        icon: <ArgonBox component="i" color="primary" fontSize="18px" className="ri-video-line" />,
        component: <AllVideos />,
        permission: ["ALL", "video"],
      },
      {
        name: "Banner",
        key: "banner",
        route: "/banner",
        icon: <ArgonBox component="i" color="#fb8c00" fontSize="18px" className="ri-image-line" />,
        component: <Banner />,
        permission: ["ALL", "banner"],
      },
      {
        name: "Blogs",
        key: "blogs",
        route: "/blogs",
        icon: (
          <ArgonBox component="i" color="#3F51B5" fontSize="18px" className="ri-file-text-line" />
        ),
        component: <Blogs />,
        permission: ["ALL", "blogs"],
      },
      {
        name: "Study Hub",
        key: "study-hub",
        route: "/study-hub",
        icon: (
          <ArgonBox component="i" color="#1565C0" fontSize="18px" className="ri-book-open-line" />
        ),
        component: <StudyHub />,
        permission: ["ALL", "studyHub"],
      },
      {
        name: "FAQ",
        key: "faq",
        route: "/faq",
        icon: (
          <ArgonBox component="i" color="#E91E63" fontSize="18px" className="ri-question-line" />
        ),
        component: <FAQ />,
        permission: ["ALL", "faq"],
      },
      {
        name: "EHC Plan",
        key: "ehc-plan-management",
        route: "/useful-corners/ehc-plan-management",
        icon: (
          <ArgonBox component="i" color="#9C27B0" fontSize="18px" className="ri-vip-crown-fill" />
        ),
        component: <EHCPlanManagement />,
        permission: ["ALL", "ehc"],
      },

      // {
      //   name:"Referral",
      //   key:"referal",
      //   route:"/referaal",
      //   icon:(<ArgonBox component="i" color="primary" fontSize="18px" className="ri-id-card-line"/>),
      //   component:<Referal/>
      // }
    ],
  },
  {
    type: "route",
    name: "Communication",
    key: "communication",
    icon: <ArgonBox component="i" color="#03A9F4" fontSize="18px" className="ri-chat-3-line" />,
    collapse: [
      {
        name: "Notification/Notice",
        key: "notification",
        route: "/notification",
        icon: <ArgonBox component="i" color="primary" fontSize="18px" className="ri-chat-1-fill" />,
        component: <Notification />,
        permission: ["ALL", "notification"],
      },
      {
        name: "OTP Logs",
        key: "otp-logs",
        route: "/otp-logs",
        icon: <ArgonBox component="i" color="primary" fontSize="18px" className="ri-key-2-line" />,
        component: <OtpLogs />,
        permission: ["ALL", "otpLogs"],
      },
      {
        name: "Message Controls",
        key: "message-controls",
        route: "/message-controls",
        icon: (
          <ArgonBox component="i" color="primary" fontSize="18px" className="ri-toggle-line" />
        ),
        component: <MessageControls />,
        permission: ["ALL", "settings"],
      },
    ],
  },
  {
    type: "route",
    name: "Finance",
    key: "finance",
    icon: (
      <ArgonBox
        component="i"
        color="#00C853"
        fontSize="18px"
        className="ri-money-dollar-circle-fill"
      />
    ),
    permission: [
      "ALL",
      "raiseInvoice",
      "draftTutorSalary",
      "allTransaction",
      "clientBalance",
      "tutorPaymentCycle",
    ],
    // component: <RTL />,
    collapse: [
      {
        name: "Draft Tutor Salary",
        key: "draft",
        route: "/draftTutorsSalary",
        icon: (
          <ArgonBox
            component="i"
            color="primary"
            fontSize="18px"
            className="ri-file-paper-2-fill"
          />
        ),
        component: <DraftTutor />,
        permission: ["ALL", "draftTutorSalary"],
      },
      {
        name: "Raise Invoice",
        key: "raise",
        route: "/raiseinvoice",
        icon: (
          <ArgonBox component="i" color="primary" fontSize="18px" className="ri-file-text-fill" />
        ),
        component: <RaiseInvoice />,
        permission: ["ALL", "raiseInvoice"],
      },
      {
        name: "All Transaction",
        key: "transaction",
        route: "/alltransactiones",
        icon: (
          <ArgonBox
            component="i"
            color="primary"
            fontSize="18px"
            className="ri-exchange-dollar-fill"
          />
        ),
        component: <AllTransaction />,
        permission: ["ALL", "allTransaction"],
      },
      {
        name: "Online Payment Tracking",
        key: "payment-order-history",
        route: "/payment-order-history",
        icon: (
          <ArgonBox
            component="i"
            color="primary"
            fontSize="18px"
            className="ri-bank-card-fill"
          />
        ),
        component: <PaymentOrderHistory />,
        permission: ["ALL", "allTransaction"],
      },
      {
        name: "Client Balance",
        key: "clientb",
        route: "/clientbalance",
        icon: <ArgonBox component="i" color="primary" fontSize="18px" className="ri-wallet-fill" />,
        component: <ClientBalance />,
        permission: ["ALL", "clientBalance"],
      },
    ],
  },

  {
    route: "/allvideos/addvideo",
    component: <AddVideo />,
  },
  {
    route: "/allvideos/editvideo/:id",
    component: <EditVideo />,
  },
  {
    route: "/study-hub/add",
    component: <StudyMaterialForm />,
    permission: ["ALL", "studyHub"],
  },
  {
    route: "/study-hub/edit/:id",
    component: <StudyMaterialForm />,
    permission: ["ALL", "studyHub"],
  },
  // {
  // type:"route",
  // name:"Test user",
  // route:"/testuser",
  // key:"test",
  // icon:(<ArgonBox component="i" color="#1976d2" sx={{fontWeight:"600"}} fontSize="18px" className="ri-user-line"/>),
  // component:<TestUser/>
  // },

  {
    route: "/banner/addbanner",
    component: <AddBanner />,
    permission: ["ALL", "banner"],
  },
  {
    route: "/banner/editbanner/:id",
    component: <EditBanner />,
    permission: ["ALL", "banner"],
  },
  {
    route: "/product/addproduct",
    component: <AddProduct />,
    permission: ["ALL"],
  },
  {
    route: "/product/editproduct/:id",
    component: <EditProduct />,
    permission: ["ALL"],
  },
  {
    route: "/product/viewproductenq/:id",
    component: <ViewProductEnq />,
    permission: ["ALL"],
  },
  {
    type: "route",
    name: "Student Leader Board",
    key: "Sleaderboard",
    route: "/Studentleaderboard",
    icon: <ArgonBox component="i" color="#FFC107" fontSize="18px" className="ri-medal-fill" />,
    component: <StudentLeaderBoard />,
    permission: ["ALL", "student_leader_board"],
  },
  {
    type: "route",
    name: "Tutor Leader Board",
    key: "Tleaderboard",
    route: "/Tutorleaderboard",
    icon: <ArgonBox component="i" color="primary" fontSize="18px" className="ri-trophy-line" />,
    component: <TutorLeaderBoard />,
    permission: ["ALL", "tutor_leader_board"],
  },
  {
    type: "route",
    name: "Report",
    key: "/report",
    icon: <ArgonBox component="i" color="#2196F3" fontSize="18px" className="ri-file-list-line" />,
    permission: ["ALL", "report"],
    collapse: [
      {
        name: "Income Breakdown",
        key: "/breakdown",
        route: "/incomebreakdown",
        icon: (
          <ArgonBox component="i" color="primary" fontSize="18px" className="ri-pie-chart-2-fill" />
        ),
        component: <IncomeBreakDown />,
      },
      {
        name: "Revenue Snapshot",
        key: "/snapshot",
        route: "/revenue",
        icon: (
          <ArgonBox component="i" color="primary" fontSize="18px" className="ri-wallet-3-fill" />
        ),
        component: <RevenueSnapshot />,
      },
      {
        name: "Income OverTime",
        key: "overtime",
        route: "/incomeovertime",
        icon: (
          <ArgonBox component="i" color="primary" fontSize="18px" className="ri-line-chart-fill" />
        ),
        component: <IncomeOverTime />,
      },
    ],
  },
  {
    type: "route",
    name: "Feedback",
    key: "feedback",
    route: "/feedbacks",
    icon: <ArgonBox component="i" color="#F44336" fontSize="18px" className="ri-feedback-fill" />,
    component: <FeedbackList />,
    permission: ["ALL", "feedback"],
  },
  // {
  //   type: "route",
  //   name: "Enquiry",
  //   key: "enquiry",
  //   route: "/newenquiries",
  //   icon: <ArgonBox component="i" color="#00BCD4" fontSize="18px" className="ri-question-line" />,
  //   component: <NewEnq />,
  //   permission: ["ALL", "ENQUIRY"],
  //   // collapse:[
  //   //   {
  //   //     name:"New Enq",
  //   //     key:"newenq",
  //   //     route:"/newenquiries",
  //   //     icon:(<ArgonBox component="i" color="primary" fontSize="18px" className="ri-chat-new-fill"/>),
  //   //     component:<NewEnq/>
  //   //   },
  //   //   {
  //   //     name:"Qualified Enq",
  //   //     key:"quelified",
  //   //     route:"/quelifiedenquieies",
  //   //      icon:(<ArgonBox component="i" color="primary" fontSize="18px" className="ri-check-double-fill"/>),
  //   //      component:<QualifiedEnq/>
  //   //   },
  //   //   {
  //   //     name:"Pending Enq",
  //   //     key:"pendingenquiries",
  //   //     route:"/pendingenquiries",
  //   //     icon:(<ArgonBox component="i" color="primary" fontSize="18px" className="ri-time-fill"/>),
  //   //     component:<PendingEnq/>
  //   //   },
  //   //   {
  //   //     name:"Disqualified Enq",
  //   //     key:"disquialified",
  //   //     route:"/disquialifiedenq",
  //   //     icon: (<ArgonBox component="i" color="primary" fontSize="18px" className="ri-close-circle-fill"/>),
  //   //     component:<DisQualifiedEnq/>
  //   //   }
  //   // ]
  // },

  // {
  //   type: "route",
  //   name: "CRM",
  //   key: "crm",
  //   route: "/crm",
  //   icon: (
  //     <ArgonBox component="i" color="#8BC34A" fontSize="18px" className="ri-bar-chart-box-fill" />
  //   ),
  //   permission: ["ALL", "CRM"],
  //   component: <UnifiedCRM />,
  // },
  // Backward compatibility routes for old CRM URLs
  {
    route: "/tutorcrm",
    component: <UnifiedCRM />,
  },
  {
    route: "/parentcrm",
    component: <UnifiedCRM />,
  },

  // { type: "title", title: "Account Pages", key: "account-pages" },
  {
    route: "/profile",
    component: <Profile />,
  },
  {
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    route: "/authentication/sign-up",
    component: <SignUp />,
  },

  {
    // type: "route",
    // name: "Add Sub-Admin",
    // key: "addSubAdmin",
    route: "/subadmin/adduser",
    component: <AddTutor />,
  },
  {
    route: "/supportticket/addticket",
    component: <AddTicket />,
  },
  {
    route: "/tutors/profile/:id",
    component: <TutorsProfile />,
  },
  {
    route: "/parents/profile/:id",
    component: <ParentProfile />,
  },

  {
    route: "/parents/profile/1",
    component: <InvoiceView />,
  },
  {
    route: "/parents/invoice-history/:parentId",
    component: <InvoiceFullHistory />,
  },
  {
    route: "/subadmin/edituser/:id",
    component: <EditUser />,
  },
  {
    route: "/classes/classSummary/:id",
    component: <ClassSummary />,
  },
  {
    route: "/ehc/viewehc",
    component: <EhcView />,
  },
  {
    route: "/attendance/profile/:id",
    component: <AttendanceListView />,
  },
  {
    route: "/creditmapping/view/:id",
    component: <CreditMappingView />,
  },
  {
    route: "/tutorpayroll/view/:id",
    component: <TutorsPayrollView />,
  },
  {
    route: "/notification/add",
    component: <AddNotification />,
  },
  {
    route: "/draftTutorsSalary/view",
    component: <DraftTutorView />,
    permission: ["ALL", "draftTutorSalary"],
  },
  {
    route: "/videoquestionsmanagement/addvideoquestionsmanagement",
    component: <AddQuestion />,
  },
  {
    route: "/videoquestionsmanagement/editvideoquestionsmanagement",
    component: <EditQuestionView />,
  },
  {
    route: "/faqs/addfaqs",
    component: <AddFaqs />,
  },
  {
    route: "/state/addstate",
    component: <AddState />,
  },
  {
    route: "/city/addcity",
    component: <AddCity />,
  },
  {
    route: "/academic/addacademic",
    component: <AddAcademic />,
  },
  {
    route: "/product/addproduct",
    component: <AddProduct />,
  },
  {
    route: "/useful-corners/support-ticket-category/add",
    component: <AddSupportTicketCategory />,
  },
  {
    route: "/useful-corners/support-ticket-category/edit/:id",
    component: <EditSupportTicketCategory />,
  },
  {
    route: "/faQs/editfAQs",
    component: <EditFaqs />,
  },
  {
    route: "/city/editcity",
    component: <EditCity />,
  },
  {
    route: "/academic/editacademic/:id",
    component: <EditAcademic />,
  },
  {
    route: "/product/editproduct",
    component: <EditProduct />,
  },
  {
    route: "/blogs/addblog",
    component: <AddBlog />,
  },
  {
    route: "/blogs/editblog/:id",
    component: <EditBlog />,
  },
  {
    route: "/faq/add",
    component: <AddFAQ />,
  },
  {
    route: "/faq/edit/:id",
    component: <EditFAQ />,
  },
  {
    route: "/faq/view/:id",
    component: <ViewFAQ />,
  },
  {
    route: "/newenquiries/viewenquiry",
    component: <NewEnquiries />,
  },
  {
    route: "/newenquiries/viewqualified",
    component: <Qualifiedview />,
  },
  {
    route: "/",
    component: <IndexPage />,
  },
  {
    route: "/curriculum/addclass",
    component: <AddClass />,
    permission: ["ALL", "class"],
  },
  {
    route: "/curriculum/editclass/:id",
    component: <EditClass />,
    permission: ["ALL", "class"],
  },
  {
    route: "/curriculum/addboard",
    component: <AddBoard />,
    permission: ["ALL", "board"],
  },
  {
    route: "/curriculum/editboard/:id",
    component: <EditBoard />,
    permission: ["ALL", "board"],
  },
  {
    route: "/curriculum/addsubject",
    component: <AddSubject />,
    permission: ["ALL", "subject"],
  },
  {
    route: "/curriculum/editsubject/:id",
    component: <EditSubject />,
    permission: ["ALL", "subject"],
  },
  {
    route: "/curriculum/addtimeslot",
    component: <AddTimeSlot />,
    permission: ["ALL", "slots"],
  },
  {
    route: "/curriculum/edittime/:id",
    component: <EditTimeSlot />,
    permission: ["ALL", "slots"],
  },
  // Demo Management Routes
  {
    route: "/demos/create",
    component: <CreateDemo />,
  },
  {
    route: "/demos/edit/:id",
    component: <EditDemo />,
  },
  {
    route: "/demos/view/:id",
    component: <ViewDemo />,
  },
  // EHC Management Routes
  {
    route: "/activities/ehc/add",
    component: <AddEHC />,
    permission: ["ALL", "ehc"],
  },
  {
    route: "/activities/ehc/edit/:id",
    component: <AddEHC />,
    permission: ["ALL", "ehc"],
  },
  {
    route: "/activities/ehc/view/:id",
    component: <ViewEHC />,
    permission: ["ALL", "ehc"],
  },
];

export default routes;






